import React from "react";
import Octicon, { Location } from "@primer/octicons-react";
import { Link } from "react-router-dom";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const Homepage = ({ sections }) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-8 mb-5">
          <h2>Kilka słów o nas</h2>
          <hr />

          <p>
            Jesteśmy zakładem kamieniarskim z rodzinnymi tradycjami. Zdobywamy nowe rynki i cieszymy się wielkim
            uznaniem klientów. Wieloletnie doświadczenie pozwala naszej firmie w prosty sposób wykonywać powierzone nam
            zadania.
          </p>

          <p>
            Wykonujemy szerokiej maści prace tj.: nagrobki pojedyncze, podwójne, grobowce, tablice pamiątkowe, schody,
            blaty, parapety i wiele innych a indywidualne projekty nie są dla nas przeszkodą.
          </p>

          <p>
            Wszystkie projekty wykonywane przez naszą firmę są wysoko cenione a świadectwem tego jest wieloletnia praca
            na rynku kamieniarskim.
          </p>

          <p>Chlubą naszej firmy są tablice wykonywane w różnych językach: hebrajskim, angielskim, niemieckim.</p>
        </div>
        <div className="col-md-4 mb-5">
          <h2>Kontakt</h2>
          <hr />
          <address>
            ul. Duninowska 2
            <br />
            87-806 Włocławek
            <br />
          </address>
          <address>
            Telefon: 600 762 522
            <br />
            Email: <a href="mailto:#">czereba@o2.pl</a>
          </address>
          <Link to="/kontact" className="btn btn-primary">
            <Octicon icon={Location} className="mr-2" />
            Zobacz jak do na dojechać
          </Link>
        </div>
      </div>

      <div className="row">
        {sections.map((section) => (
          <div className="col-md-6 mb-5">
            <div className="card h-100">
              <img className="card-img-top" alt="" />
              <div className="card-body">
                <h4 className="card-title">{section.fields.title}</h4>
                {documentToReactComponents(section.fields.description)}
              </div>
              {/* <div className="card-footer">
                <Link to={`/${section.fields.slug}`} className="btn btn-primary">
                  Dowiedz się więcej
                </Link>
              </div> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Homepage;
